import { render } from "./TheMonHoc.vue?vue&type=template&id=8ee475c2"
import script from "./TheMonHoc.vue?vue&type=script&lang=js"
export * from "./TheMonHoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__